import { render } from "./VisitorGuardianStudentMatrix.vue?vue&type=template&id=74251052&scoped=true"
import script from "./VisitorGuardianStudentMatrix.vue?vue&type=script&lang=js"
export * from "./VisitorGuardianStudentMatrix.vue?vue&type=script&lang=js"

import "./VisitorGuardianStudentMatrix.vue?vue&type=style&index=0&id=74251052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74251052"]])

export default __exports__